import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKrFlag = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 50,
	height: 50,
	viewBox: "0 0 50 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_1339_53953)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M49.1378 41.3792H0.862108C0.386034 41.3792 0 40.9932 0 40.5171V9.48271C0 9.00664 0.386034 8.62061 0.862108 8.62061H49.1379C49.614 8.62061 50 9.00664 50 9.48271V40.5171C49.9999 40.9933 49.6139 41.3792 49.1378 41.3792Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M10.1924 13L11.3128 13.9805L6.12041 19.848L5 18.8675L10.1924 13ZM12.0402 14.5868L13.1606 15.5673L8.15436 21.3498L7.03395 20.3692L12.0402 14.5868ZM15 17.1736L13.8795 16.1931L8.85939 22.0194L9.97981 23L15 17.1736Z",
					fill: "#272727"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M38.7165 13L37.6197 14.0309L39.522 16.3602L40.6187 15.3293L38.7165 13ZM42.0977 17.2847L41.001 18.3156L42.9034 20.6449L44 19.614L42.0977 17.2847ZM34 17.386L35.0967 16.3551L36.999 18.6844L35.9023 19.7153L34 17.386ZM38.478 20.6398L37.3813 21.6707L39.2836 24L40.3803 22.9691L38.478 20.6398ZM35.8785 15.6584L36.9753 14.6275L42.2703 21.3558L41.1736 22.3867L35.8785 15.6584Z",
					fill: "#272727"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M40.4149 27.9533L39.2798 27L37.3106 29.1539L38.4458 30.1072L40.4149 27.9533ZM37.1043 31.7437L35.9691 30.7904L34 32.9443L35.1352 33.8976L37.1043 31.7437ZM42.8648 30.0146L44 30.9678L42.031 33.1217L40.8957 32.1685L42.8648 30.0146ZM40.8513 34.8461L39.7161 33.8929L37.7469 36.0468L38.8822 37L40.8513 34.8461ZM37.846 32.255L38.9812 33.2083L36.9257 35.5082L35.7906 34.5549L37.846 32.255ZM42.3535 29.3758L41.2183 28.4225L39.1628 30.7226L40.2981 31.6758L42.3535 29.3758Z",
					fill: "#272727"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M8.75971 28.0071L9.90198 27L15 32.7114L13.8577 33.7184L8.75971 28.0071ZM9.9489 33.0025L11.0912 31.9953L13.2445 34.3084L12.1023 35.3155L9.9489 33.0025ZM6.14226 30.2047L5 31.2119L10.1245 37L11.2667 35.9929L6.14226 30.2047ZM6.95501 29.5474L8.09728 28.5403L9.96402 30.6806L8.82176 31.6877L6.95501 29.5474Z",
					fill: "#272727"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M24.5001 33C29.1945 33 33 29.1945 33 24.5C33 19.8056 29.1945 16 24.5001 16C19.8055 16 16 19.8056 16 24.5C16 29.1945 19.8055 33 24.5001 33Z",
					fill: "#3D58DB"
				}),
				/* @__PURE__ */ _jsx("mask", {
					id: "mask0_1339_53953",
					style: { maskType: "luminance" },
					maskUnits: "userSpaceOnUse",
					x: 16,
					y: 16,
					width: 17,
					height: 18,
					children: /* @__PURE__ */ _jsx("path", {
						fillRule: "evenodd",
						clipRule: "evenodd",
						d: "M24.5001 33.001C29.1945 33.001 33 29.1955 33 24.501C33 19.8066 29.1945 16.001 24.5001 16.001C19.8055 16.001 16 19.8066 16 24.501C16 29.1955 19.8055 33.001 24.5001 33.001Z",
						fill: "white"
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					mask: "url(#mask0_1339_53953)",
					children: /* @__PURE__ */ _jsx("path", {
						fillRule: "evenodd",
						clipRule: "evenodd",
						d: "M33.2969 25.1507C33.2969 25.1507 32.8198 21.1426 29.2863 20.925C25.753 20.7074 24.8002 23.8642 24.5964 24.7006C24.3925 25.537 23.8764 27.7681 20.156 27.7681C16.4358 27.7681 16.1001 22.095 16.1001 22.095V15.4053H33.2969V25.1507Z",
						fill: "#CD343C"
					})
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_1339_53953",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 50,
				height: 50,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgKrFlag);
export { ForwardRef as ReactComponent };
